<template>
  <div class="col-sm-auto py-2">
    <!-- Button trigger modal -->
    <button class="btn btn-outline-primary btn-sm my-auto"
            data-toggle="modal" data-target="#addDrugAlcoholTest"
            style="opacity: .75">
      <i class="fas fa-plus"></i>
      Add New
    </button>
    <!-- Modal -->
    <div class="modal fade" id="addDrugAlcoholTest" tabindex="-1" role="dialog" aria-labelledby="addDrugAlcoholTestTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="addDrugAlcoholTestTitle">Add New Drug & Alcohol Test</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form action="" class="small">
            <div class="modal-body">
              <div class="form-group row mb-0">
                <label for="testDate" class="col-sm-3 col-form-label">Test Date :</label>
                <div class="col-sm-9">
                  <input type="date" id="testDate" class="form-control form-control-sm">
                </div>
              </div>
              <div class="form-group row mb-0">
                <label class="col-sm-3 col-form-label">Test Result :</label>
                <div class="col-sm-9 py-2">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="testResult" id="positive" value="positive">
                    <label class="form-check-label" for="positive">POSITIVE</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="testResult" id="negative" value="negative">
                    <label class="form-check-label" for="negative">NEGATIVE</label>
                  </div>
                </div>
              </div>
              <div class="form-group row mb-0">
                <label for="testBy" class="col-sm-3 col-form-label">Test By :</label>
                <div class="col-sm-9">
                  <input type="text" id="testBy" class="form-control form-control-sm">
                </div>
              </div>
              <div class="form-group row mb-1">
                <label for="testRemarks" class="col-sm-3 col-form-label">Remarks :</label>
                <div class="col-sm-9">
                   <textarea class="form-control form-control-sm" id="testRemarks" rows="5"
                             style="resize: none"></textarea>
                </div>
              </div>
              <div class="form-group row mb-2">
                <label for="testFile" class="col-sm-3 col-form-label">Attachment :</label>
                <div class="col-sm-9">
                  <div class="custom-file">
                    <input type="file" class="custom-file-input form-control-sm" id="testFile">
                    <label class="custom-file-label" for="testFile">Drug & Alcohol Attachment</label>
                  </div>
                </div>
              </div>
              <div class="row mb-0">
                <div class="col-sm-12 text-right">
                  <button type="button" class="btn btn-outline-success btn-sm border-0">
                    <i class="fas fa-plus-circle"></i>
                    Attachment
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm mx-1" data-dismiss="modal">
                <i class="fas fa-times"></i>
                Close
              </button>
              <button type="button" class="btn btn-primary btn-sm">
                <i class="fas fa-save"></i>
                Add Test
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "AddDrugAlcoholTest"
}
</script>

<style scoped>

</style>